module.exports = __webpack_public_path__ + "img/dcr.34691308.svg";